module.exports = __webpack_public_path__ + "img/icon_证书_E级赛事@3x.0566c14f.png";